/**
 * @generated SignedSource<<d9c7052efccbbf723d8ba8f8bad1e5e3>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserRecommendationsGrid_user$data = {
  readonly serviceId: string | null;
  readonly twoTowerModelItemRecommendations: {
    readonly recommendationIds: ReadonlyArray<string>;
  } | null;
  readonly " $fragmentType": "UserRecommendationsGrid_user";
};
export type UserRecommendationsGrid_user$key = {
  readonly " $data"?: UserRecommendationsGrid_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserRecommendationsGrid_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": "PERSONALIZED",
      "kind": "LocalArgument",
      "name": "recommendationType"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserRecommendationsGrid_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "type",
          "variableName": "recommendationType"
        }
      ],
      "concreteType": "UserRecommendations",
      "kind": "LinkedField",
      "name": "twoTowerModelItemRecommendations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "recommendationIds",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "892c3dbfc023c8521a77e6c80ca63a4c";

export default node;
